import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { UserService } from '@shared/services/user.service';
import { AuthStorageService } from '@core/services/auth-storage.service';
import { NavigateService } from '@core/routes/services/navigate.service';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@core/services/snackbar.service';
import { PricingService } from '@modules/pricing/shared/services/pricing.service';
import { PermissionType } from '@modules/graphql/graphql-types';
import { Observable, of } from 'rxjs';

@Injectable()
export class TacticSettingsCanActivateGuard implements CanActivate {
  constructor(
    private userService: UserService,
    private authStorageService: AuthStorageService,
    private n: NavigateService,
    private s: SnackbarService,
    private t: TranslateService,
    private pricingService: PricingService,
  ) {}

  canActivate(): Observable<boolean> {
    if (this.userService.User && this.authStorageService.jwt) {
      return this.pricingService.checkPricing(PermissionType.TacticsCreate);
    }
    this.s.error(this.t.instant('Sign in to access the application'));
    this.n.go('sign-in');
    return of(false);
  }
}
